// web/src/components/StageBanner.tsx — Home banners for a paused, ending or ended site (portal spec 14, 01 §3a).
// Card and plan changes go through Stripe's page (api.portal, spec 15). No time promises.
import { useState } from 'react';
import { api } from '../lib/api';
import type { HomeSite } from '../lib/types';
import { Icon } from './Icon';
import { toast } from './Toast';

export function StageBanner({ site }: { site: Pick<HomeSite, 'stage'> }) {
  const [busy, setBusy] = useState(false);
  const portal = async () => {
    setBusy(true);
    try { window.location.href = (await api.portal()).url; }
    catch { toast({ kind: 'error', message: 'Couldn’t open the billing page. Try again in a minute.' }); }
    finally { setBusy(false); }
  };
  if (site.stage === 'paused') return (
    <div className="rounded-lg border border-hair border-l-4 border-l-danger bg-surface p-5">
      <h2 className="flex items-center gap-2 font-head text-ink"><Icon name="alert" size={18} className="text-danger" />Your payment didn’t go through</h2>
      <p className="mt-1 text-sm text-muted">Please update your card to keep your website online and improving.</p>
      <button onClick={portal} disabled={busy} className="mt-3 inline-flex min-h-11 items-center rounded-md bg-run px-4 font-medium text-runink disabled:opacity-50">Update my card</button>
    </div>
  );
  if (site.stage === 'offboarding') return (
    <div className="rounded-lg border border-hair border-l-4 border-l-warn bg-surface p-5">
      <h2 className="font-head text-ink">Your plan is ending</h2>
      <p className="mt-1 text-sm text-muted">Your site stays up until the end of the period you’ve paid for. Then we send you your DNS records and a copy of your site, so you can take it anywhere. Changed your mind?</p>
      <button onClick={portal} disabled={busy} className="mt-3 inline-flex min-h-11 items-center rounded-md border border-hair px-4 text-ink disabled:opacity-50">Keep my plan</button>
    </div>
  );
  return (
    <div className="rounded-lg border border-hair bg-surface p-5">
      <h2 className="font-head text-ink">Your hosting has ended</h2>
      <p className="mt-1 text-sm text-muted">Thanks for working with us. If you want to come back, email hello@yourproject.ai.</p>
    </div>
  );
}
